module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-body form"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          運費說明\n          "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sInfo.shipping_description),
      expression: "sInfo.shipping_description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.sInfo.shipping_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sInfo, "shipping_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.sInfo.shipping_description ? _vm.sInfo.shipping_description.length : 0) + "/100")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          運費計算\n        ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.feeTypeSelect),
      expression: "feeTypeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.feeTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("不計算運費")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("依訂單金額計算")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("依運送距離計算")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("依運送距離+訂單金額計算")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.showVendorId) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          POS廠商ID\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vendorCustomId),
      expression: "vendorCustomId"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.vendorCustomId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vendorCustomId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.feeTypeSelect === 1) ? [_c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("新增運費")]), _vm._v(" "), (_vm.$route.name !== 'batchSetupStore') ? _c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#openModal"
    }
  }, [_vm._v("複製運費至其他店家")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_c('span', [_vm._v("訂單金額")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  計算商品金額 (折扣前) ，不含塑膠袋。\n                ")])], 1)]), _vm._v(" "), _c('td', [_vm._v("運費設定")]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itemList), function(item, iIndex) {
    return _c('tr', [_c('td', [(item.money === -1) ? [(_vm.itemList[iIndex - 1]) ? [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("＄ " + _vm._s(_vm.maxValue(_vm.itemList, 'money') + 1) + " 以上 \n                ")] : [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("不限金額\n                ")]] : [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("\n                ＄ "), _c('input', {
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "金額",
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": _vm.itemList[iIndex - 1] ? (_vm.itemList[iIndex - 1].money * 1 + 1) : 0
      }
    }), _vm._v("\n                ～\n                ＄ "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.money),
        expression: "item.money",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "金額",
        "type": "text"
      },
      domProps: {
        "value": (item.money)
      },
      on: {
        "change": function($event) {
          return _vm.updateValue(_vm.itemList, 'money')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "money", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]], 2), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("\n              運費 $ "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.fee),
        expression: "item.fee",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "運費",
        "type": "text"
      },
      domProps: {
        "value": (item.fee)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "fee", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', [(item.money > -1) ? _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeItemTime(iIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])
  }), 0)])] : _vm._e(), _vm._v(" "), (_vm.feeTypeSelect === 2) ? [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("新增運費")]), _vm._v(" "), (_vm.$route.name !== 'batchSetupStore') ? _c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#openModal"
    }
  }, [_vm._v("複製運費至其他店家")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.itemListKM), function(item, iIndex) {
    return _c('tr', [_c('td', [(item.distance === -1) ? [(_vm.itemListKM[iIndex - 1]) ? [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v(_vm._s(_vm.numeral(_vm.maxValue(_vm.itemListKM, 'distance')).add(0.1).value()) + " 公里以上\n                ")] : [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("不限距離\n                ")]] : [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v(" "), _c('input', {
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "距離",
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": _vm.itemListKM[iIndex - 1] ? (_vm.numeral(_vm.itemListKM[iIndex - 1].distance).add(0.1).value()) : 0
      }
    }), _vm._v(" 公里\n                ～\n                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.distance),
        expression: "item.distance",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "距離",
        "type": "text"
      },
      domProps: {
        "value": (item.distance)
      },
      on: {
        "change": function($event) {
          return _vm.updateValue(_vm.itemListKM, 'distance')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "distance", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" 公里\n              ")]], 2), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("\n              運費 $ "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.fee),
        expression: "item.fee",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "運費",
        "type": "text"
      },
      domProps: {
        "value": (item.fee)
      },
      on: {
        "change": function($event) {
          return _vm.updateValue(_vm.itemListKM, 'distance')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "fee", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', [(item.distance > -1) ? _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeItemTime(iIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])
  }), 0)])] : _vm._e(), _vm._v(" "), (_vm.feeTypeSelect === 3) ? [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("新增運費")]), _vm._v(" "), (_vm.$route.name !== 'batchSetupStore') ? _c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#openModal"
    }
  }, [_vm._v("複製運費至其他店家")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable deliveryTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("運送距離")]), _vm._v(" "), _c('td', [_c('span', [_vm._v("訂單金額")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  計算商品金額 (折扣前) ，不含塑膠袋。\n                ")])], 1)]), _vm._v(" "), _c('td', [_vm._v("運費設定")]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.itemListKM), function(item, iIndex) {
    return [_c('tr', {
      class: iIndex % 2 ? 'even' : 'odd'
    }, [_c('td', {
      attrs: {
        "rowspan": item.range.length + 1
      }
    }, [(_vm.itemList.length == 1) ? [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("不限距離\n                ")] : (item.distance == -1) ? [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v(_vm._s(_vm.numeral(_vm.maxValue(_vm.itemListKM, 'distance')).add(0.1).value()) + " 公里以上\n                ")] : [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v(" "), _c('input', {
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "距離",
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": _vm.itemListKM[iIndex - 1] ? (_vm.numeral(_vm.itemListKM[iIndex - 1].distance).add(0.1).value()) : 0
      }
    }), _vm._v(" 公里\n                  ～\n                  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.distance),
        expression: "item.distance",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "距離",
        "type": "text"
      },
      domProps: {
        "value": (item.distance)
      },
      on: {
        "change": function($event) {
          return _vm.updateValue(_vm.itemListKM, 'distance')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "distance", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" 公里\n                ")]], 2)]), _vm._v(" "), _vm._l((item.range), function(range, index) {
      return _c('tr', {
        class: iIndex % 2 ? 'even' : 'odd'
      }, [_c('td', [(range.money == -1) ? [_c('span', {
        staticClass: "text-red"
      }, [_vm._v("＊ ")]), _vm._v("$ " + _vm._s(_vm.maxValue(item.range, 'money') + 1) + " 以上\n                ")] : [_c('span', {
        staticClass: "text-red"
      }, [_vm._v("＊ ")]), _vm._v("\n                  $ "), _c('input', {
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "金額",
          "type": "text",
          "disabled": ""
        },
        domProps: {
          "value": item.range[index - 1] ? (item.range[index - 1].money * 1 + 1) : 0
        }
      }), _vm._v("\n                  ～\n                  $ "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.number",
          value: (range.money),
          expression: "range.money",
          modifiers: {
            "number": true
          }
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "金額",
          "type": "text"
        },
        domProps: {
          "value": (range.money)
        },
        on: {
          "click": function($event) {
            return _vm.updateValue(item.range, 'money')
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(range, "money", _vm._n($event.target.value))
          },
          "blur": function($event) {
            return _vm.$forceUpdate()
          }
        }
      })], _vm._v(" "), (index == 0) ? _c('button', {
        staticClass: "btn btn-success",
        on: {
          "click": function($event) {
            item.range.splice(item.range.length - 1, 0, {
              money: item.range[index - 1] ? (item.range[index - 1].money * 1 + 1) : 0,
              fee: 0
            });
            _vm.updateValue(item.range, 'money');
            _vm.$forceUpdate()
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-plus-circle",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e()], 2), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "text-red"
      }, [_vm._v("＊ ")]), _vm._v("運費 $ "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.number",
          value: (range.fee),
          expression: "range.fee",
          modifiers: {
            "number": true
          }
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "運費",
          "type": "text"
        },
        domProps: {
          "value": (range.fee)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(range, "fee", _vm._n($event.target.value))
          },
          "blur": function($event) {
            return _vm.$forceUpdate()
          }
        }
      })]), _vm._v(" "), _c('td', [(range.money > -1 && (item.range.length > 2 || item.distance > -1)) ? _c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            item.range.length == 2 ? _vm.removeItemTime(iIndex) : item.range.splice(index, 1);
            _vm.$forceUpdate()
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })]) : _vm._e()])])
    })]
  })], 2)])] : _vm._e(), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "openModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('div', [_c('h5', {
    staticClass: "text-left"
  }, [_vm._v("參與店家")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.copyShipping
    }
  }, [_vm._v("確定")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("運費設定")]), _vm._v(" "), _c('div', [_vm._v("請確認POS端是否支援此功能")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n              紅框處，即為「運費說明」的文字內容，將顯示於菜單頁的訂餐資訊中 。\n              "), _c('img', {
    attrs: {
      "alt": "運費說明圖片",
      "src": "/static/img/shipping_description.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v(" 距離請勿超過「取餐方式/門檻」設定的最遠可外送距離。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("運送距離")]), _vm._v(" "), _c('td', [_vm._v("運費設定")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v(" 距離請勿超過「取餐方式/門檻」設定的最遠可外送距離。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("複製此分店運費至其他店家")]), _vm._v(" "), _c('p', {
    staticClass: "text-light-gray"
  }, [_vm._v("計算類型、運費描述依然需至該店設定")]), _vm._v(" "), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6909aa70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Brand/Temp/ShippingForm.vue
// module id = 2466
// module chunks = 1